import { IAnalyticsEvent } from '@verv-inc/js-toolkit';

const eventName = 'AB_TEST';

export const GTMABTestEvent = {
	sendABtestEvent: (ABName: string, ABGroup: string): IAnalyticsEvent => {
		return {
			name: eventName,
			info: {
				ab_name: ABName,
				ab_group: ABGroup,
				ab_test_type: 'payment_page',
			},
		};
	},
};
